import React from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Button, Card, Form, Image } from "react-bootstrap";

// Import background
import heroBg from "../../images/hero-img.png";

const HeroSection4 = () => {
  return (
    <motion.section initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }} className="position-relative hero-section min-vh-100  text-center" id="home">
      {/* Background Image with Overlay */}
      <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }} className="position-absolute top-0 start-0 w-100 h-100">
        <Image src={heroBg} alt="Background" className="w-100 h-100 object-fit-cover" />
      </motion.div>
      <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }} className="overlay"></motion.div>

      {/* Content */}
      <Container className="position-relative">
        <Row className="justify-content-center text-center">
          <Col xl={8} lg={9} md={10} className="px-4">
            {/* Heading */}
            <h1 className="display-3 fw-bold mb-3"> Your <span className="text-danger">Perfect Meal</span> Awaits 🍴 </h1>
            <p className="lead mx-auto mb-4 text-muted" > From street-style favorites to gourmet delights — explore, order, and enjoy food that’s made with love and delivered with care. </p>

            <Row className="justify-content-center text-center">
              <Col xl={8} lg={9} md={10} className="px-4">
                {/* Search Bar */}
                <Form className="d-flex justify-content-center mb-4" >
                  <Form.Control type="text" placeholder="Search for dishes, cuisines, or chefs..." className="rounded-start-pill" />
                  <Button variant="danger" className="rounded-end-pill">Search</Button>
                </Form>
              </Col>
            </Row>

            {/* Buttons */}
            <div className="d-flex justify-content-center flex-wrap gap-3 mb-5">
              <Button variant="danger" size="lg">View Menu</Button>
              <Button variant="dark" size="lg">Join as Chef</Button>
            </div>

            {/* Stats Strip */}
            <Row className="g-4 justify-content-center mb-5">
              <Col md={3}>
                <Card className="card-hover menu-item-card h-100 mb-0">
                  <Card.Body>
                    <h2 className="fw-bold text-danger">500+</h2>
                    <p className="mb-0">Curated Recipes</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="card-hover menu-item-card h-100 mb-0">
                  <Card.Body>
                    <h2 className="fw-bold text-danger">1M+</h2>
                    <p className="mb-0">Happy Foodies</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="card-hover menu-item-card h-100 mb-0">
                  <Card.Body>
                    <h2 className="fw-bold text-danger">4.9/5</h2>
                    <p className="mb-0">Top Rated Service</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Newsletter */}
            <Card className="card-hover menu-item-card mb-0 mx-auto" style={{ maxWidth: "700px" }}>
              <Card.Body>
                <h4 className="fw-bold mb-3">Subscribe for Exclusive Offers</h4>
                <Form className="d-flex">
                  <Form.Control type="email" placeholder="Enter your email" className="rounded-start-pill" />
                  <Button variant="danger" className="rounded-end-pill">Subscribe</Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default HeroSection4;
